var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function quickSort(array) {
    // Базовый случай: если массив содержит 0 или 1 элемент, он уже отсортирован
    if (array.length <= 1) {
        return array;
    }
    // Выбор опорного элемента (pivot)
    var pivot = array[Math.floor(array.length / 2)];
    // Разделение массива на три части: меньше pivot, равные pivot, больше pivot
    var less = array.filter(function (num) { return num < pivot; });
    var equal = array.filter(function (num) { return num === pivot; });
    var greater = array.filter(function (num) { return num > pivot; });
    // Рекурсивно сортируем "меньшие" и "большие" части, и объединяем результат
    return __spreadArray(__spreadArray(__spreadArray([], quickSort(less), true), equal, true), quickSort(greater), true);
}
